export const mapsStyles = {
  wrapper: {
    maxWidth: {
      mobile: "100%",
      laptop: "69.4375rem",
    },
    margin: {
      laptop: "auto",
    },
  },
  container: {
    margin: {
      mobile: "0 0 5rem 0",
      tablet: "0 2.5rem 7.5rem",
      laptop: "0 0 2rem",
    },
  },
  imageWrapper: {
    margin: 0,
    padding: 0,
    overflow: "hidden",
    height: {
      mobile: "20rem",
      tablet: "20.375rem",
      laptop: "19.5rem",
    },
    mb: {
      tablet: "1.5rem",
      laptop: "unset",
    },
    borderRadius: {
      tablet: "0.9375rem",
    },
  },
  mapImages: {
    width: "100%",
    height: "auto",
    objectFit: "cover",
  },
  textWrapper: {
    position: "relative",
    bgcolor: "sand",
    zIndex: 1050,
    borderRadius: {
      tablet: "0.9375rem",
    },
    overflow: {
      mobile: "hidden",
    },
    width: {
      laptop: "45.625rem",
    },
    height: {
      laptop: "19.5rem",
    },
  },
  bgImageWrapper: {
    position: "absolute",
    zIndex: 1050,
    width: "100vw",
    overflow: "hidden",
    top: {
      tablet: "-16.25rem",
    },
    left: {
      tablet: "0.313rem",
    },
    height: {
      mobile: "24rem",
      tablet: "unset",
    },
  },
  textContainer: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    padding: {
      mobile: "2.5rem 1.5rem",
      tablet: "5.5rem 4.69rem",
    },
    textAlign: {
      mobile: "center",
      tablet: "left",
    },
  },
  title: {
    color: "peach.main",
    textTransform: "capitalize",
    zIndex: 1100,
  },
  contactsWrapper: {
    pt: {
      tablet: "1.5rem",
    },
  },
};
